module.exports = "https://lts-static.prod-my.games/promo/lp1/img/weapon-2-selected.6bb8169a.png";